import React from 'react';
import PropTypes from "prop-types";

const AttachmentPreview = ({ imageSrc, imageAlt, overlayIconComponent, overlayText, onClick }) => (
  <div className="attachment-preview flex flex-center" onClick={e => onClick && onClick(e)}>
    <span className="attachment-preview-overlay flex flex-column flex-center">
      {overlayIconComponent}
      <span>{overlayText}</span>
    </span>
    <img className="attachment-preview-media" src={imageSrc} alt={imageAlt} />
  </div>
);

AttachmentPreview.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  overlayIconComponent: PropTypes.element.isRequired,
  overlayText: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default AttachmentPreview;

